class Test {
    test(val) {
		if (val / 3 == 2) {
			return true
		} else {
			return false
		}
	}
}
export default new Test();